import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  Changes,
  getDefaults as getActivityDefaults,
} from 'models/Activity';

export interface ImportPatientFieldChangesOptions extends ActivityOptions {
  type: ActivityType.IMPORT_PATIENT_FIELD_CHANGES;
  data: Partial<BaseActivityDataOptions & { enteredAt: string; changes: Changes }>;
}

export function getDefaults(): ImportPatientFieldChangesOptions {
  const defaults = getActivityDefaults();
  return {
    ...defaults,
    type: ActivityType.IMPORT_PATIENT_FIELD_CHANGES,
    data: {
      ...defaults.data,
      enteredAt: '',
      changes: [],
    },
  };
}

export default class ImportPatientFieldChanges extends Activity {
  declare type: ActivityType.IMPORT_PATIENT_FIELD_CHANGES;
  declare data: BaseActivityData & { enteredAt: string; changes: Changes };

  constructor(options: Partial<ImportPatientFieldChangesOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
  }

  get typeLabel() {
    return 'Patient Details';
  }
}
